import { useState } from "react";
import { getUserDetailsSuccessType, getUserDetailsErrorType, UserPermissions } from "../../APIDocs/apiTypes";
import { Observable, ObservableEvents } from "./Observable";
import { useGetUserInfoQuery } from "./hooks/useJbpQuery";
import { Logger } from "./Logger";
import { Model } from "./Model";

export class User {
    private static user: User | undefined;
    private userPermissions: UserPermissions | undefined;
    private userType: string | undefined;

    private constructor() {
        this.userPermissions = undefined;
        this.userType = undefined;
    }

    public static GetUser = (): User => {
        if(User.user === undefined) {
            User.user = new User();
        }
        return User.user;
    }

    public canAccess = (permission: keyof UserPermissions): boolean => {
        if(this.userPermissions === undefined) {
            const userPermissionsString: string = Model.GetModel().Get("viewModel.fetchedData.UserPermissionsForCurrentUser");
            let userPermissionsFromModel: UserPermissions | undefined = undefined;
            try {
                userPermissionsFromModel = JSON.parse(userPermissionsString);
                return userPermissionsFromModel?.[permission] === true;
            } catch(error) {
                if(error instanceof SyntaxError) {
                    return false;
                } else {
                    console.error(error);
                    return false;
                }
            }
        }
        return this.userPermissions?.[permission] === true;
    }

    public storeUserPermissions = (permissions: UserPermissions | undefined) => {
        if(permissions !== undefined) {
            this.userPermissions = permissions;
            Model.GetModel().Set("viewModel.fetchedData.UserPermissionsForCurrentUser", JSON.stringify(permissions));
        } else {
            console.error("Attempted to store undefined user permissions.");
        }
    }

    public getUserType = (): string | undefined => {
        if(this.userType !== undefined) {
            return this.userType;
        }
        this.userType = Model.GetModel().Get("viewModel.fetchedData.UserTypeForCurrentUser");
        return this.userType;
    }

    public isInternalUser = (): boolean => {
        return this.getUserType() === "INTERNAL";
    }

    public isSupplierUser = (): boolean => {
        return this.getUserType() === "SUPPLIER";
    }

    // Thought below was nice to have, but might not be needed
    public fetchUserPermissions = (): UserPermissions | undefined => {
        const [dataErrorOccurred, setDataErrorOccurred] = useState(false);

        const onUserVerification = (userData: getUserDetailsSuccessType) => {
            Model.GetModel().Set("viewModel.fetchedData.UserTypeForCurrentUser", userData.userType);
            Model.GetModel().Set("viewModel.fetchedData.ValidMPIDSForCurrentUser", userData.mpid);
            Model.GetModel().Set("viewModel.fetchedData.UserRoleForCurrentUser", userData.role);
            Model.GetModel().Set("viewModel.fetchedData.UserPermissionsForCurrentUser", JSON.stringify(userData.permissions));

            Observable.GetObservable().emit(ObservableEvents.UserInfoLoaded, userData.user);
            this.storeUserPermissions(userData.permissions as UserPermissions | undefined);
            return this.userPermissions
        }

        const onUserVerificationError = (err: getUserDetailsErrorType) => {
            Logger.Log(`Error occurred validating the user details -> ${err?.msg}`)
            setDataErrorOccurred(true);
        }

        const { isLoading: userDataLoading, data } = useGetUserInfoQuery<getUserDetailsSuccessType, getUserDetailsErrorType>(true, onUserVerification, onUserVerificationError)
        while(userDataLoading) {
            // Wait for user data to load
        }
        if(dataErrorOccurred || data === undefined || data.permissions === undefined) {
            console.error("Failed to fetch user permissions or data error occurred.");
            return undefined;
        }
    }
}
